<div class="dialog-title-des">
  <h2 mat-dialog-title>{{dialogTitle}}</h2>

  <button *ngIf="helpHintText" class="ai-dialog-btn ai-btn-link" (click)="openAiChat()">
    <span class="material-symbols-outlined">auto_fix</span>
    <span>{{helpHintText}}</span>
  </button>

</div>

<mat-dialog-content [formGroup]="form">

  <mat-form-field appearance="outline" *ngIf="showTitle">

    <input matInput [placeholder]="titlePlaceHolder" formControlName="title">

  </mat-form-field>

  <rich-text-editor #editor *ngIf="mode == 'rich-text'" [modules]="editorConfig" [html]="description"
    [placeholder]="descriptionPlaceholder" height="300px">

  </rich-text-editor>



  <mat-form-field appearance="outline" *ngIf="mode == 'plain-text'">

    <textarea matInput class="plain-text" [placeholder]="descriptionPlaceholder" #plainText>

      </textarea>

  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">

  <button mat-raised-button (click)="close()">
    {{"common.close" | translate}}
  </button>

  <button mat-raised-button color="primary" (click)="save()" [disabled]="!form.valid">
    {{saveButtonText}}
  </button>

</mat-dialog-actions>
